export default __webpack_public_path__ + "static/media/l31.60308e13.png";